import React, { PropTypes } from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import Toggle from "react-toggle";
import { bindActionCreators } from "redux";
import simpleFetch from "../../../../../../utils/simpleFetch";
import LocaleUtils from "../../../../../utils/LocaleUtils";
import { ADMINISTRATOR, DIRECTOR, FINANCE, FINTECH, MANAGER, PLAN_ADMINISTRATOR } from "../../../../../utils/Roles";
import SchedulerInformations from "../../../../../utils/SchedulerInformations";
import * as dataActions from "../../../../../utils/data/dataActions";
import { BILLING_PERIODS, CLIENT_V2, CLIENTS, INVOICES_TABLE } from "../../../../../utils/data/models";
import userHasAccess from "../../../../../utils/userHasAccess";
import { BSModal, EditButton, Render } from "../../../../common";
import LanguageToggle from "../../../../common/LanguageToggle/LanguageToggle";
import { MANUAL, RECURRING } from "../../enums/billingPeriodTypes";
import { IMPLEMENTATION, INACTIVE, TERMINATED } from "../../enums/clientStatusTypes";
import { BillingPeriodFilter } from "../members";
import { BasicBillingAddressFields } from "./";
import TemplateInvoiceButton from "./TemplateInvoiceButton";
import { FAILURE, GENERATING } from "./enums/invoiceStatuses";
import { FINAL } from "./enums/invoiceSteps";
import moment from "moment";
import { toast } from "react-toastify";

class InvoiceDataTableHeader extends React.Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			showModal: false,
			isReviewValue: null,
			workingDaysValue: {},
			activeBP: null,
			currentClientStatus: null,
			clientAlreadyHasInvoice: null,
			currentBillingPeriodId: null,
			fetchingWorkingDays: false
		};
		this.generateFilterButton = this.generateFilterButton.bind(this);
		this.openModal = this.openModal.bind(this);
		this.closeWithModifications = this.closeWithModifications.bind(this);
		this.closeWithoutModifications = this.closeWithoutModifications.bind(this);
		this.rightActionButton = this.rightActionButton.bind(this);
		this.editBillingAddress = this.editBillingAddress.bind(this);
		this.setStateWorkingDaysReviewPhase = this.setStateWorkingDaysReviewPhase.bind(
			this
		);
		this.setStateIsReviewPhase = this.setStateIsReviewPhase.bind(this);
		this.setCurrentBillingPeriodId = this.setCurrentBillingPeriodId.bind(this);
		this.refreshDataTable = this.refreshDataTable.bind(this);
		this.isFinalizedForBillingPeriod = this.isFinalizedForBillingPeriod.bind(this);
		this.isSchedulerToggleDisable = this.isSchedulerToggleDisable.bind(this);
		this.renderIsValidMessage = this.renderIsValidMessage.bind(this);

		this.canGenerateTemplateInvoice = userHasAccess([DIRECTOR, FINANCE, ADMINISTRATOR, FINTECH], true);
	}

	componentDidMount() {
		const activeBillingPeriod = this.props.client.isBilledPreviousPeriod
			? this.props.activeBillingPeriods[1]
			: this.props.activeBillingPeriods[0];
		this.setStateIsReviewPhase(activeBillingPeriod);
		this.setStateWorkingDaysReviewPhase();
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.items && !this.state.clientAlreadyHasInvoice) {
			/**
				* Checking if user has invoices to set state (only once).
				*/
			this.setState({ clientAlreadyHasInvoice: nextProps.items.length > 0 });
		}
		if (nextProps.client && !this.state.currentClientStatus) {
			this.setState({ currentClientStatus: nextProps.client.clientStatusType });
		}
		if (
			this.props.billingPeriods.length == 0 &&
			nextProps.billingPeriods.length > 0
		) {
			this.setCurrentBillingPeriodId(nextProps.billingPeriods);
		}
	}

	setStateWorkingDaysReviewPhase() {
		simpleFetch("GET", `/v1/scheduler/scheduled-dates`, {}).then((response) => {
			this.setState({ workingDaysValue: response, fetchingWorkingDays: true });
		});
	}

	setStateIsReviewPhase(activeBillingPeriod) {
		if (activeBillingPeriod != this.state.activeBP) {
			let url = `/v1/billing-periods/is-review-phase`;
			simpleFetch("GET", url, {}).then((response) => {
				this.setState({
					isReviewValue: response[0],
					activeBP: activeBillingPeriod,
				});
			});
		}
	}

	refreshDataTable() {
		const additionalFilters = this.props.client.clientBillingPeriodType == RECURRING.value ? [...this.props.filters, "distinct==True"] : this.props.filters;
		return this.props.dataActions.getDataList(
			INVOICES_TABLE,
			this.props.offset,
			this.props.limit,
			this.props.q,
			this.props.sortBy,
			additionalFilters,
			null
		);
	}

	closeWithoutModifications() {
		this.setState({ showModal: false });
	}

	openModal() {
		this.setState({ showModal: true });
	}

	closeWithModifications() {
		this.setState({ showModal: false });
		const { chosenBillingPeriodFilter, fetchBillingPeriods } = this.props;

		const billingPeriodId = chosenBillingPeriodFilter.billingPeriodId;
		this.props.dataActions.updateDataItem(BILLING_PERIODS, {
			billingPeriodId,
			isDelayed: true,
		}).then((res) => {
			if (res && res.type === "UPDATE_DATA_ITEM_FAILURE") {
				if (res.payload && res.payload.error && res.payload.error.status === 401) {
					toast(<FormattedMessage id="invoices.datatable.actions.unauthorizedDelayAction" />, {
						type: toast.TYPE.ERROR,
						autoClose: false,
					});
				}
			}
			fetchBillingPeriods();
		});
	}

	setCurrentBillingPeriodId(billingPeriods) {
		const options = billingPeriods.map((period) => {
			return {
				value: period.billingPeriodId,
				text: period.localizations[this.props.authLanguageCode].name,
			};
		});
		const defaultValue = options[0] ? options[0].value : null;
		this.setState({ currentBillingPeriodId: defaultValue });
	}

	generateFilterButton() {
		const options = this.props.billingPeriods.map((period) => {
			return {
				value: period.billingPeriodId,
				text: period.localizations[this.props.authLanguageCode].name,
			};
		});
		const defaultValue = options[0] ? options[0].value : null;

		return (
			<BillingPeriodFilter
				initialValues={{ billingPeriodFilter: defaultValue }}
				onChange={this.props.updateBillingPeriodFilter}
				options={this.props.billingPeriods.map((period) => ({
					value: period.billingPeriodId,
					text: period.localizations[this.props.authLanguageCode].name,
				}))}
			/>
		);
	}

	editBillingAddress(values) {
		const {
			client: { clientId },
			dataActions,
		} = this.props;
		let model = JSON.parse(JSON.stringify(CLIENTS));
		model.identifier = "billingInfoModelIdentifier";
		values.billingInfoModelIdentifier = `${clientId}/billing-info`;
		values.clientId = clientId;
		values.includeWithdrawalMembers = !!values.includeWithdrawalMembers;
		values.mustUngroupGuarantees = !!values.mustUngroupGuarantees;
		values.showPaymentNotice = !!values.showPaymentNotice;
		
		dataActions.updateDataItem(model, values).then(() => {
			dataActions.getDataItem(CLIENT_V2, clientId);
		});
	}

	isFinalizedForBillingPeriod() {
		/**
		 * For MANUAL clients, we only check the isFinalized flag to disable the delay bp toggle.
		 * For RECURRENT clients, we need to check if the bp already has a final invoice.
		 */
		const { client, chosenBillingPeriodFilter, activeInvoice } = this.props;

		if (client.clientBillingPeriodType === MANUAL.value) {
			return chosenBillingPeriodFilter.isFinalized;
		}

		const eventualFinalInvoice = activeInvoice[0];
		if (!this.props.fetched) {
			return true;
		}
		if (eventualFinalInvoice) {
			return eventualFinalInvoice != undefined &&
				eventualFinalInvoice.invoiceStep == FINAL.value &&
				eventualFinalInvoice.invoiceStatusType != FAILURE.value;
		}

		return false;
	}

	isSchedulerToggleDisable() {
		if (!this.state.fetchingWorkingDays) {
			/** Disable toggle as long as working days is not fetched. */
			return true;
		}
		const { invoicesGenerationDate, invoicesCreationDate } = this.state.workingDaysValue;

		if (invoicesGenerationDate && invoicesCreationDate) {
			const today = moment().startOf('day');
			const invoicesGenerationDateObj = moment(invoicesGenerationDate).toDate();
			const invoicesCreationDateObj = moment(invoicesCreationDate).toDate();

			return today >= invoicesGenerationDateObj || today < invoicesCreationDateObj;
		}
		return false;
	}

	rightActionButton(client) {
		const { billingInfo, isBillable, clientStatusType } = client;
		const { billingPeriods, clientId, updateValidity, invoices, activeInvoice, chosenBillingPeriodFilter } = this.props;
		const disableToggleForClientStatus = client.clientStatusType == INACTIVE.value || client.clientStatusType == TERMINATED.value;
		const chosenBillingPeriodName = chosenBillingPeriodFilter ? chosenBillingPeriodFilter.localizations[this.props.authLanguageCode].name : "";

		let isDelayed = chosenBillingPeriodFilter ? chosenBillingPeriodFilter.isDelayed : false;
		let mapping = {};
		mapping.bpName = chosenBillingPeriodName;
		const isFinalized = this.isFinalizedForBillingPeriod();
		const toggleDisableForSchedulerDates = this.isSchedulerToggleDisable();
		const eventualFinalInvoice = activeInvoice[0];
		let isGenerating =
			eventualFinalInvoice != undefined &&
			eventualFinalInvoice.invoiceStatusType == GENERATING.value;
		return (
			<Render for={[MANAGER]}>
				{this.state.currentClientStatus == IMPLEMENTATION.value &&
					!this.state.clientAlreadyHasInvoice &&
					this.canGenerateTemplateInvoice &&
					isBillable && (
						<TemplateInvoiceButton
							clientId={clientId}
							refreshDataTable={this.refreshDataTable}
							isGenerating={isGenerating}
							updateValidity={updateValidity}
							invoices={invoices}
							billingPeriods={billingPeriods.map((period) => ({
								value: period.billingPeriodId,
								text: period.localizations[this.props.authLanguageCode].name,
								startDate: period.startDate,
							}))}
						/>
					)}
				<label className="block-coverage-withdrawal">
					<div className="invoice">
						<div className="toggleText">
							<FormattedMessage id="invoices.datatable.actions.invoiceOffset" values={{ bpName: chosenBillingPeriodName }} />
						</div>
						<Toggle
							defaultChecked={isDelayed}
							disabled={isFinalized || isDelayed || !this.state.isReviewValue || disableToggleForClientStatus || toggleDisableForSchedulerDates}
							checked={isDelayed}
							icons={{
								checked: <span className="icon icon-checkmark" />,
								unchecked: null,
							}}
							onChange={this.openModal}
						/>
					</div>
				</label>
				<br />
				<Render if={this.state.showModal}>
					<BSModal
						show={this.state.showModal}
						title={
							<FormattedMessage id="admin.blocs.datatable.actions.showConfirm.title">
								{(f) => <span className="icon warning">{f}</span>}
							</FormattedMessage>
						}
						closeButtonKey="common.close"
						onClose={this.closeWithoutModifications}
						actions={[
							{
								id: 1,
								text: <FormattedMessage id="common.confirm" />,
								action: this.closeWithModifications,
							},
						]}
					>
						<FormattedMessage
							id="invoices.datatable.actions.modalInvoiceDelayedWarning"
							values={mapping}
						>
							{(m) => (
								<div
									className="formatted-confirmation"
									dangerouslySetInnerHTML={{ __html: m }}
								/>
							)}
						</FormattedMessage>
					</BSModal>
				</Render>
				<EditButton
					className={
						"edit-billing-address-" +
						LocaleUtils.extractLangFromLocale(
							localStorage.getItem("languageCode")
						)
					}
					title={
						<FormattedMessage id="invoices.datatable.actions.editBillingAddress" />
					}
					label={
						<FormattedMessage id="invoices.datatable.actions.editBillingAddress" />
					}
					datatableActionButton={false}
					form={BasicBillingAddressFields}
					clientStatusType={clientStatusType}
					allowSubmission={!(clientStatusType === TERMINATED.value && !userHasAccess(FINTECH))}
					hideEye={true}
					props={{ clientStatusType }}
					data={billingInfo}
					editFunction={this.editBillingAddress}
					confirmationTitle={
						<FormattedMessage id="admin.blocs.datatable.actions.showConfirm.title">
							{(f) => <span className="icon warning">{f}</span>}
						</FormattedMessage>
					}
					confirmationMessage={
						<FormattedMessage id="admin.blocs.datatable.actions.showConfirm.message" />
					}
					requiresCloseConfirmation={true}
					confirmOnClose={true}
					reverseIcon={true}
				/>
			</Render>
		);
	}

	renderIsValidMessage(isValid) {
		if (isValid) {
			return (
				<div className="center-client-invoice-message">
					<FormattedMessage id="invoices.datatable.actions.normalMessage" />
				</div>
			);
		}
		if (!userHasAccess(PLAN_ADMINISTRATOR, true)) {
			return (
				<div className="dataTable-invoice-message-warning">
					<span className="icon icon-warning" />
					<FormattedMessage id="invoices.datatable.actions.warning" />
					<FormattedMessage id="invoices.datatable.actions.warningMessage" />
				</div>
			);
		}
	}

	render() {
		const { activeBillingPeriods, isValid } = this.props;

		return (
			<div>
				<SchedulerInformations activeBillingPeriods={activeBillingPeriods} />
				<div className="datatable-actions-section line-jumping">
					<div>
						<div className="datatable-flex">
							{this.generateFilterButton()}
							<div className="w-100">
								<div className="dataTable-add-button">
									{this.rightActionButton(this.props.client)}
									{userHasAccess(PLAN_ADMINISTRATOR, true) ? (
										<div
											className={
												"invoice-toggle-margin-pa-" +
												LocaleUtils.extractLangFromLocale(
													localStorage.getItem("languageCode")
												)
											}
										>
											<LanguageToggle
												setLanguageCode={this.props.languageCode}
												flexClasses="invoice-toggle-justify"
											/>
										</div>
									) : (
										<div
										>
											<LanguageToggle
												setLanguageCode={this.props.languageCode}
												flexClasses="invoice-toggle-justify"
											/>
										</div>
									)}
								</div>
								{this.renderIsValidMessage(isValid)}
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

InvoiceDataTableHeader.propTypes = {
	languageCode: PropTypes.func.isRequired,
	activeBillingPeriods: PropTypes.array.isRequired,
	billingPeriods: PropTypes.array.isRequired,
	authLanguageCode: PropTypes.string.isRequired,
	dataActions: PropTypes.object,
	filters: PropTypes.array,
	items: PropTypes.array,
	updateBillingPeriodFilter: PropTypes.func.isRequired,
	clientId: PropTypes.number.isRequired,
	client: PropTypes.object.isRequired,
	activeInvoice: PropTypes.array.isRequired,
	limit: PropTypes.number,
	offset: PropTypes.number,
	q: PropTypes.string,
	sortBy: PropTypes.array,
	isValid: PropTypes.bool,
	updateValidity: PropTypes.func,
	chosenBillingPeriodFilter: PropTypes.object,
	invoices: PropTypes.oneOfType([
		PropTypes.object,
		PropTypes.array,
	]),
	fetchBillingPeriods: PropTypes.func,
	fetched: PropTypes.bool
};

function mapDispatchToProps(dispatch) {
	return {
		dataActions: bindActionCreators(dataActions, dispatch),
	};
}

function mapStateToProps(state) {
	const data = state.data.invoiceDataFront || {};
	const activeInvoice = data || {};

	/**
	 * Checking the status of fetched invoices is necessary here, in order to
	 * deactivate the delay invoice button until the "fetched" property in the store is set to true.
	 */

	return {
		fetched: activeInvoice.fetched
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceDataTableHeader);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/invoices/InvoicesDataTableHeader.js